import React from "react";
import { connect } from "react-redux";
import { AgBytesAPI } from "@ai360/core";

import {
    toProductDropdownOptions,
    useLoggedInUserProductScopeOrgLevelGuid,
    useProductList,
} from "~/utils/products/use-product-list";
import { toSelectableCropDropdownOptions, useCropList } from "~/utils/crops/use-crop-list";

import AddEditPanelContainer from "./../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { dropdowns, model, pickLists, service, PRODUCT_DROPDOWN } from "./../data";
import { fetchDropdownData } from "~/core/dropdowns/actions";
import { getDropdown } from "~/admin/selectors";

const mapStateToProps = (state) => ({
    [model.PROPS_GROWTH_STAGE_ORDER]: getDropdown(model.PROPS_GROWTH_STAGE_ORDER, state),
});

const mapDispatchToProps = () => ({
    fetchGrowthStage: (v) => fetchDropdownData(v),
});

const ConnectedAddEditPanel = connect(
    mapStateToProps,
    mapDispatchToProps
)(AddEditPanelContainer(AddEditPanel, { dropdowns, pickLists, service }));

const AddEditContainer = (props) => {
    const orgLevelGuid = useLoggedInUserProductScopeOrgLevelGuid();
    const { products } = useProductList({
        orgLevelGuid,
        scope: AgBytesAPI.ProductSelectionListScope.UserHierarchy,
    });
    const { crops } = useCropList({ orgLevelGuid });

    return (
        <ConnectedAddEditPanel
            {...props}
            {...{
                [PRODUCT_DROPDOWN]: toProductDropdownOptions(products),
                [model.PROPS_CROP_NAME]: toSelectableCropDropdownOptions(crops),
            }}
        />
    );
};

export default AddEditContainer;
